import emoji from 'images/sad.png';
import { FEEDBACK_ALERT_ERROR_TITLE } from 'tracker.constants';

const ERROR_DESCRIPTION =
  'Algo deu errado por aqui, mas você pode tentar de novo.';

const RETRY_MESSAGE = 'Quero tentar';

const FEEDBACK_ALERT_PROPS = {
  illustration: emoji,
  title: FEEDBACK_ALERT_ERROR_TITLE,
  description: ERROR_DESCRIPTION
};

export { ERROR_DESCRIPTION, RETRY_MESSAGE, FEEDBACK_ALERT_PROPS };
